export const brightRed = '#e52b44'
export const blueGray = '#f2f5f8'
export const darkBlue = '#353f51'
export const darkPink = '#c33c54'
export const lightBlue = '#9db8ea'
export const lightBlueDarker = '#7B90B7'
export const lightGray = '#b6b9bB'
export const white = '#fbfffe'
